<template>
  <v-navigation-drawer
    style="background-color: #f5f8fa; border: None"
    permanent
    :width="navbar.barWidth"
    :class="[
      { 'drawer-overlay': isHovering && !navbar.isFixed },
      { 'is-collapsed': !navbar.isExpanded }
    ]"
    :style="isHovering && !navbar.isFixed ? { width: `${navbar.expandWidth}px` } : {}"
    @mouseenter="onDrawerEnter"
    @mouseleave="onDrawerLeave"
  >
    <div class="h-100 d-flex flex-column justify-space-between">
      <div class="nav-scroll">
        <v-list density="compact" class="d-flex flex-column align-start">
          <v-list density="compact" class="w-100" v-model:opened="openGroups">
            <v-list-group
              v-if="canAccessInsights"
              value="insights"
              class="w-100"
              :class="{ 'insights-active': insightsMenuActive }"
              expand-icon="mdi-menu-down"
              collapse-icon="mdi-menu-up"
            >
              <template v-slot:activator="{ props }">
                <v-list-item
                  v-bind="props"
                  class="nav-link dropdownPredict d-flex justify-start align-center w-100 px-5 py-3"
                  :class="{ 'insights-active': insightsMenuActive }"
                >
                  <svg
                    :class="{ 'svg-active': insightsMenuActive }"
                    width="24"
                    height="24"
                    viewBox="-1 0 17.6 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.38302 7.32358L6.47509 8.58704L2.4307 12.688L1.33863 11.4246L5.38302 7.32358Z"
                      fill="#505353"
                    />
                    <path
                      d="M9.33591 10.672L8.12833 11.8353L5.47039 8.59461L6.67796 7.43132L9.33591 10.672Z"
                      fill="#505353"
                    />
                    <path
                      d="M9.13769 12.4413L8.14916 11.3282L13.0284 6.24777L14.0169 7.36085L9.13769 12.4413Z"
                      fill="#505353"
                    />
                    <path
                      d="M7.46742 8.02532C7.39666 8.89476 6.68868 9.54545 5.8861 9.47867C5.08353 9.41189 4.49028 8.65293 4.56105 7.78349C4.63181 6.91405 5.33979 6.26336 6.14237 6.33014C6.94494 6.39692 7.53819 7.15588 7.46742 8.02532Z"
                      fill="#505353"
                    />
                    <path
                      d="M2.9121 12.5419C2.84134 13.4114 2.13336 14.0621 1.33078 13.9953C0.52821 13.9285 -0.065038 13.1696 0.00572688 12.3001C0.0764917 11.4307 0.784473 10.78 1.58705 10.8468C2.38962 10.9135 2.98287 11.6725 2.9121 12.5419Z"
                      fill="#505353"
                    />
                    <path
                      d="M10.4291 11.5825C10.3583 12.4519 9.65034 13.1026 8.84776 13.0358C8.04519 12.9691 7.45194 12.2101 7.5227 11.3407C7.59347 10.4712 8.30145 9.82053 9.10402 9.88731C9.9066 9.95409 10.4998 10.713 10.4291 11.5825Z"
                      fill="#505353"
                    />
                    <path
                      d="M15.3943 6.44463C15.3235 7.31407 14.6155 7.96476 13.813 7.89798C13.0104 7.8312 12.4171 7.07224 12.4879 6.2028C12.5587 5.33336 13.2666 4.68268 14.0692 4.74946C14.8718 4.81624 15.465 5.57519 15.3943 6.44463Z"
                      fill="#505353"
                    />
                    <path
                      d="M9.4225 5.20381C9.49062 5.35878 9.70783 5.35966 9.77717 5.20525L10.4817 3.63655C10.5012 3.5931 10.5357 3.55831 10.5787 3.53867L12.1077 2.84075C12.2625 2.77009 12.2596 2.54684 12.103 2.48035L10.5254 1.81042C10.5023 1.80058 10.4838 1.78206 10.4738 1.75873L9.7741 0.11871C9.70698 -0.0386265 9.48676 -0.0398473 9.41793 0.116736L8.73421 1.67217C8.71473 1.7165 8.67972 1.75198 8.63591 1.77179L7.07899 2.47563C6.92558 2.54499 6.92558 2.76518 7.07899 2.83453L8.63591 3.53838C8.67972 3.55818 8.71473 3.59366 8.73421 3.63799L9.4225 5.20381Z"
                      fill="#505353"
                    />
                    <path
                      d="M1.8442 7.32358C1.88102 7.47247 2.0903 7.47247 2.12711 7.32358L2.45047 6.01579C2.46353 5.96297 2.50432 5.92173 2.55657 5.90852L3.85 5.58157C3.99726 5.54435 3.99726 5.33275 3.85 5.29552L2.55657 4.96858C2.50432 4.95537 2.46353 4.91413 2.45047 4.86131L2.12711 3.55352C2.0903 3.40463 1.88102 3.40463 1.8442 3.55352L1.52084 4.86131C1.50778 4.91413 1.46699 4.95537 1.41475 4.96858L0.121315 5.29552C-0.025946 5.33275 -0.0259457 5.54435 0.121316 5.58157L1.41475 5.90852C1.46699 5.92173 1.50778 5.96297 1.52084 6.01579L1.8442 7.32358Z"
                      fill="#505353"
                    />
                  </svg>

                  <v-text
                    class="dropdown-text mt-1 transition-text"
                    :class="{
                      'text-active': insightsMenuActive,
                      'collapsed': !navbar.isExpanded
                    }"
                  >
                    {{ breakText("Insights", 30) }}
                  </v-text>
                </v-list-item>
              </template>
              <v-list-item class="nav-link-wrapper clickable-item">
                <a
                  class="nav-link d-flex justify-start ga-2 align-center w-100 py-3"
                  href=""
                  @click.prevent="handleInsightsNavigation('/data')"
                >
                  <svg
                    class="nav-icon"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="2 0 20 22"
                    fill="none"
                  >
                    <path
                      d="M12 12C16.5563 12 20.25 9.98528 20.25 7.5C20.25 5.01472 16.5563 3 12 3C7.44365 3 3.75 5.01472 3.75 7.5C3.75 9.98528 7.44365 12 12 12Z"
                      :stroke="dadosMenuActive ? '#0da6a6' : 'currentColor'"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M3.75 7.5V12C3.75 14.4853 7.44365 16.5 12 16.5C16.5563 16.5 20.25 14.4853 20.25 12V7.5"
                      :stroke="dadosMenuActive ? '#0da6a6' : 'currentColor'"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M3.75 12V16.5C3.75 18.9853 7.44365 21 12 21C16.5563 21 20.25 18.9853 20.25 16.5V12"
                      :stroke="dadosMenuActive ? '#0da6a6' : 'currentColor'"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>

                  <v-text
                    class="barItemText transition-text"
                    :style="dadosMenuActive ? 'color: #0da6a6 !important' : ''"
                    :class="{ 'collapsed': !navbar.isExpanded }"
                  >
                    {{ breakText("Dados", 30) }}
                  </v-text>
                </a>
              </v-list-item>
              <v-list-item class="nav-link-wrapper clickable-item">
                <a
                  class="nav-link d-flex justify-start ga-2 align-center w-100 py-3"
                  href=""
                  @click.prevent="handleInsightsNavigation('/model')"
                >
                  <svg
                    class="nav-icon"
                    width="24"
                    height="24"
                    viewBox="0 0 20 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      :stroke="modelosMenuActive ? '#0da6a6' : 'currentColor'"
                      d="M10 21V11M10 11L18.73 5.96002M10 11L1.27 5.96002M19 15.008V6.99002C18.9994 6.64109 18.9066 6.29851 18.731 5.99699C18.5554 5.69548 18.3032 5.44572 18 5.27302L11 1.26502C10.6953 1.09141 10.3507 1.00012 10 1.00012C9.64932 1.00012 9.30469 1.09141 9 1.26502L2 5.27302C1.381 5.62802 1 6.28302 1 6.99102V15.009C1 15.718 1.381 16.372 2 16.726L9 20.734C9.30469 20.9076 9.64932 20.9989 10 20.9989C10.3507 20.9989 10.6953 20.9076 11 20.734L18 16.726C18.619 16.371 19 15.716 19 15.008Z"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>

                  <v-text
                    class="barItemText transition-text"
                    :style="modelosMenuActive ? 'color: #0da6a6 !important' : ''"
                    :class="{ 'collapsed': !navbar.isExpanded }"
                  >
                    {{ breakText("Modelos", 30) }}
                  </v-text>
                </a>
              </v-list-item>
            </v-list-group>
          </v-list>

          <router-link
            v-if="canAccessAssistentes"
            @click="generateJWTAndRedirect"
            class="nav-link d-flex justify-start ga-1 align-center px-5 py-3"
            :to="{ name: 'assistentes' }"
            :class="{ 'icon-active': isAssistentesActive }"
          >
            <svg
              class="nav-icon"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="40"
              viewBox="-4 4 24 30"
              fill="none"
            >
              <path
                d="M7.76402 7.11316C7.85824 7.32498 8.15866 7.32619 8.25458 7.11513L9.22905 4.97085C9.25604 4.91145 9.30374 4.8639 9.36324 4.83705L11.478 3.88305C11.6921 3.78648 11.688 3.48131 11.4715 3.39043L9.2895 2.47469C9.25746 2.46124 9.23187 2.43592 9.21811 2.40403L8.25034 0.162267C8.15749 -0.0527991 7.85291 -0.0544678 7.75771 0.159568L6.81204 2.28571C6.78509 2.34631 6.73666 2.39481 6.67608 2.42188L4.52267 3.38397C4.31048 3.47878 4.31048 3.77976 4.52267 3.87456L6.67608 4.83666C6.73666 4.86372 6.78509 4.91222 6.81204 4.97282L7.76402 7.11316Z"
                fill="currentColor"
              />

              <path
                d="M0 29.091V23.8385C0 23.2607 0.195833 22.7661 0.5875 22.3546C0.979167 21.9432 1.45 21.7374 2 21.7374H14C14.55 21.7374 15.0208 21.9432 15.4125 22.3546C15.8042 22.7661 16 23.2607 16 23.8385V29.091H0ZM5 20.6869C3.61667 20.6869 2.4375 20.1748 1.4625 19.1506C0.4875 18.1263 0 16.8876 0 15.4344C0 13.9812 0.4875 12.7425 1.4625 11.7182C2.4375 10.694 3.61667 10.1819 5 10.1819H11C12.3833 10.1819 13.5625 10.694 14.5375 11.7182C15.5125 12.7425 16 13.9812 16 15.4344C16 16.8876 15.5125 18.1263 14.5375 19.1506C13.5625 20.1748 12.3833 20.6869 11 20.6869H5ZM2 26.99H14V23.8385H2V26.99ZM5 18.5859H11C11.8333 18.5859 12.5417 18.2795 13.125 17.6667C13.7083 17.0539 14 16.3098 14 15.4344C14 14.559 13.7083 13.8149 13.125 13.2021C12.5417 12.5893 11.8333 12.2829 11 12.2829H5C4.16667 12.2829 3.45833 12.5893 2.875 13.2021C2.29167 13.8149 2 14.559 2 15.4344C2 16.3098 2.29167 17.0539 2.875 17.6667C3.45833 18.2795 4.16667 18.5859 5 18.5859ZM5 16.4849C5.28333 16.4849 5.52083 16.3842 5.7125 16.1829C5.90417 15.9815 6 15.7321 6 15.4344C6 15.1368 5.90417 14.8873 5.7125 14.6859C5.52083 14.4846 5.28333 14.3839 5 14.3839C4.71667 14.3839 4.47917 14.4846 4.2875 14.6859C4.09583 14.8873 4 15.1368 4 15.4344C4 15.7321 4.09583 15.9815 4.2875 16.1829C4.47917 16.3842 4.71667 16.4849 5 16.4849ZM11 16.4849C11.2833 16.4849 11.5208 16.3842 11.7125 16.1829C11.9042 15.9815 12 15.7321 12 15.4344C12 15.1368 11.9042 14.8873 11.7125 14.6859C11.5208 14.4846 11.2833 14.3839 11 14.3839C10.7167 14.3839 10.4792 14.4846 10.2875 14.6859C10.0958 14.8873 10 15.1368 10 15.4344C10 15.7321 10.0958 15.9815 10.2875 16.1829C10.4792 16.3842 10.7167 16.4849 11 16.4849Z"
                fill="currentColor"
              />
            </svg>

            <v-text
              class="barItemText transition-text"
              :class="{ 'collapsed': !navbar.isExpanded }"
            >
              {{ breakText("Assistente", 30) }}
            </v-text>
          </router-link>

          <router-link
            v-if="canAccessContentGeneration"
            @click="generateJWTAndRedirect"
            class="nav-link d-flex justify-start ga-1 align-center px-5 py-3"
            :to="{ name: 'content-generation' }"
            :class="{ 'icon-active': isContentGenerationActive }"
          >
            <svg
              class="nav-icon"
              width="20"
              height="20"
              viewBox="0 0 10 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.33352 0.192493C5.44806 -0.0649943 5.81459 -0.0628309 5.92629 0.195911L7.09084 2.89316C7.10742 2.9314 7.13831 2.96197 7.17678 2.97812L9.80177 4.07967C10.0623 4.18902 10.0671 4.55625 9.80958 4.67244L7.26516 5.81989C7.19363 5.85217 7.13651 5.90963 7.10402 5.98102L5.93166 8.56108L5.90725 8.60552C5.78112 8.79985 5.48995 8.79875 5.36526 8.60356L5.34133 8.55864L4.19582 5.98347C4.17149 5.92878 4.13268 5.88226 4.08401 5.8487L4.03225 5.81989L1.44143 4.66219C1.18619 4.54812 1.18619 4.18592 1.44143 4.07186L4.03225 2.91464C4.08694 2.89021 4.13353 2.85106 4.16702 2.80234L4.19582 2.75058L5.33352 0.192493ZM4.92678 3.07577C4.81406 3.32914 4.61145 3.53157 4.35842 3.64462L2.74172 4.36678L4.35842 5.08943C4.61144 5.20247 4.81406 5.40491 4.92678 5.65827L5.64113 7.26471L6.37551 5.64997C6.4884 5.40164 6.68804 5.20299 6.93654 5.09089L8.48195 4.39315L6.86721 3.71542C6.63809 3.61926 6.45453 3.43834 6.35598 3.21005L5.62258 1.51084L4.92678 3.07577Z"
                fill="currentColor"
              />
              <path
                d="M1.67432 9.91323C1.64881 10.0152 1.51882 10.0279 1.46728 9.95131L1.45068 9.91323L1.43554 9.85317L1.5625 9.8849L1.68897 9.85317L1.67432 9.91323ZM1.45068 6.96299C1.47982 6.84648 1.64518 6.84648 1.67432 6.96299L1.93018 7.98644C1.94052 8.02775 1.97286 8.06009 2.01417 8.07043L2.97756 8.31115L3.0093 8.43811L2.97756 8.56457L2.01417 8.80579C1.97286 8.81613 1.94052 8.84846 1.93018 8.88977L1.68897 9.85317L1.5625 9.8849L1.43554 9.85317L1.19482 8.88977C1.18448 8.84846 1.15214 8.81613 1.11083 8.80579L0.0873776 8.54992C-0.0291258 8.52079 -0.0291259 8.35543 0.0873776 8.32629L1.11083 8.07043C1.15214 8.06009 1.18448 8.02775 1.19482 7.98644L1.45068 6.96299ZM3.03762 8.32629C3.15413 8.35543 3.15413 8.52079 3.03762 8.54992L2.97756 8.56457L3.0093 8.43811L2.97756 8.31115L3.03762 8.32629Z"
                fill="currentColor"
              />
            </svg>

            <v-text
              class="barItemText transition-text"
              :class="{ 'collapsed': !navbar.isExpanded }"
            >
              {{ breakText("Geração de conteúdo", 30) }}
            </v-text>
          </router-link>
        </v-list>
      </div>

      <button
        v-tooltip="navbar.isFixed ? 'Desafixar barra lateral' : 'Fixar barra lateral'"
        @click="toggleFixed"
        class="toggle-button d-flex flex-column align-self-end mb-5 mr-2 px-3 py-3"
        :class="{ 'is-fixed': navbar.isFixed }"
      >
        <svg width="14" height="13" viewBox="1 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M2.06223 12.4388L0.662231 11.0388L5.26223 6.43884L0.662231 1.83884L2.06223 0.438843L8.06223 6.43884L2.06223 12.4388ZM11.0622 12.4388V0.438843H13.0622V12.4388H11.0622Z"
            fill="#4D4D4D"
          />
        </svg>
      </button>
    </div>
    <RbPopupInsightsHiring
      v-model="insightsHiring.popupOpen"
      @hired="handleInsightsHired"
    />
  </v-navigation-drawer>
</template>

<script setup>
import { ref, reactive, onMounted, watch, computed } from 'vue'
import { useInsightsHiringStore } from '@/ai_studio/stores/insightsHiring.store'
import RbPopupInsightsHiring from '@/captacao/components/hiring/RbPopupInsightsHiring.vue'
import { Get } from '@/ai_studio/http/http.js'
import { useRoute, useRouter } from 'vue-router'
import { useUserStore } from '@/ai_studio/stores/user'
import { PERMISSIONS } from '@/ai_studio/constants/permissions'

const route = useRoute()
const router = useRouter()
const userStore = useUserStore()

const openGroups = ref([])
const token = ref(null)

const insightsHiring = useInsightsHiringStore()

const insightsRouteNames = [
  'data',
  'model',
  'datadefinitions',
  'configuration'
]

const assistentesRouteNames = [
  'assistentes',
  'assistentesCreation',
  'assistentesEdit',
  'assistentsShare',
  'assistentsIntegration'
]

const isInsightsRoute = computed(() => {
  return insightsRouteNames.includes(route.name)
})

const isInsightsGroupOpen = computed(() => {
  return openGroups.value.includes('insights')
})

const insightsMenuActive = computed(() => {
  return isInsightsRoute.value && !isInsightsGroupOpen.value
})

const dadosMenuActive = computed(() => {
  return route.name === 'data' || route.name === 'datadefinitions'
})

const modelosMenuActive = computed(() => {
  return route.name === 'model' || route.name === 'configuration'
})

const isAssistentesActive = computed(() => {
  return assistentesRouteNames.includes(route.name)
})

const isContentGenerationActive = computed(() => {
  return route.name === 'content-generation'
})

const canAccessInsights = computed(() => {
  return userStore.hasPermission(PERMISSIONS.INSIGHTS)
})

const canAccessAssistentes = computed(() => {
  return userStore.hasPermission(PERMISSIONS.ASSISTENTES)
})

const canAccessContentGeneration = computed(() => {
  return userStore.hasPermission(PERMISSIONS.GERACAO_CONTEUDO)
})

const navbar = reactive({
  barWidth: 0,
  shrinkWidth: 64,
  expandWidth: 215.5,
  isExpanded: false,
  isFixed: false
})

const isHovering = ref(false)
let hoverTimer = null
const isTransitioning = ref(false)
const showText = ref(false)

const TRANSITION_MS = 100

const handleInsightsNavigation = async (targetRoute) => {
  await insightsHiring.accessInsights(router, targetRoute)
}

const handleInsightsHired = async () => {
  await insightsHiring.markAsHired()
  insightsHiring.redirectAfterHiring(router, '/model')
}

const startTransition = () => {
  isTransitioning.value = true
  showText.value = false
}

const endTransition = () => {
  isTransitioning.value = false
  showText.value = navbar.isExpanded
}

const onDrawerEnter = () => {
  if (navbar.isFixed) return
  if (hoverTimer) clearTimeout(hoverTimer)
  hoverTimer = setTimeout(() => {
    startTransition()
    isHovering.value = true
    navbar.isExpanded = true
    setTimeout(endTransition, TRANSITION_MS)
  }, 1000)
}

const onDrawerLeave = () => {
  if (hoverTimer) clearTimeout(hoverTimer)
  if (navbar.isFixed) return
  startTransition()
  isHovering.value = false
  navbar.isExpanded = false
  if (!navbar.isFixed) {
    shrinkBar()
  }
  setTimeout(endTransition, TRANSITION_MS)
}

const generateJWTAndRedirect = async () => {
  token.value = await Get('getjwt')
  localStorage.setItem('assistentesToken', token.value)
}

const expandBar = () => {
  navbar.barWidth = navbar.expandWidth
  navbar.isExpanded = true
  document.documentElement.style.setProperty('--sidebar-width', `${navbar.barWidth}px`)
  setTimeout(endTransition, TRANSITION_MS)
}

const shrinkBar = () => {
  startTransition()
  navbar.barWidth = navbar.shrinkWidth
  navbar.isExpanded = false
  document.documentElement.style.setProperty('--sidebar-width', `${navbar.barWidth}px`)
  setTimeout(endTransition, TRANSITION_MS)
}

const toggleFixed = () => {
  navbar.isFixed = !navbar.isFixed
  if (navbar.isFixed) {
    expandBar()
  } else {
    if (!isHovering.value) {
      shrinkBar()
    }
  }
}

const breakText = (text, maxLen = 30) => {
  const words = text.split(' ')
  const lines = []
  let line = ''

  for (const w of words) {
    const candidate = line ? `${line} ${w}` : w

    if (candidate.length <= maxLen) {
      line = candidate
    } else {
      if (line) lines.push(line)

      if (w.length > maxLen) {
        const parts = w.match(new RegExp(`.{1,${maxLen}}`, 'g')) || [w]
        lines.push(...parts.slice(0, -1))
        line = parts[parts.length - 1]
      } else {
        line = w
      }
    }
  }

  if (line) lines.push(line)
  return lines.join('\n')
}

onMounted(async () => {
  const savedFixed = localStorage.getItem('navFixed')
  navbar.isFixed = savedFixed ? JSON.parse(savedFixed) : false
  navbar.barWidth = navbar.isFixed ? navbar.expandWidth : navbar.shrinkWidth
  navbar.isExpanded = navbar.isFixed
  document.documentElement.style.setProperty('--sidebar-width', `${navbar.barWidth}px`)
  showText.value = navbar.isExpanded

  await insightsHiring.fetchStatus()
})

watch(
  () => [navbar.isFixed, navbar.barWidth],
  ([isFixed, width]) => {
    localStorage.setItem('navFixed', JSON.stringify(isFixed))
    document.documentElement.style.setProperty('--sidebar-width', `${width}px`)
  }
)
</script>

<style scoped>
.nav-link {
  width: 100%;
  height: 48px;
  color: rgb(var(--v-theme-neutral-35));
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  text-decoration: none !important;
}

.nav-link .nav-icon {
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.nav-link:hover {
  background-color: rgba(13, 166, 166, 0.1);
}

.nav-link-wrapper {
  width: 100%;
  height: 48px;
  border-radius: 4px;
  overflow: hidden;
}

.nav-link-wrapper:hover,
.clickable-item:hover {
  background-color: rgba(13, 166, 166, 0.1);
}

.nav-link-wrapper:hover .nav-link,
.clickable-item:hover .nav-link {
  background-color: transparent;
}

.clickable-item :deep(.v-list-item__content) {
  display: flex !important;
  margin-left: 4px;
  gap: 6px;
  align-items: center;
  width: 100%;
}

.clickable-item :deep(.v-list-item__prepend) {
  margin-inline-end: 8px !important;
}

.v-list {
  padding: 0 !important;
}

.dropdownPredict {
  display: flex !important;
  width: 100% !important;
  justify-content: space-between !important;
}

.dropdownPredict :deep(.v-list-item__content) {
  display: flex !important;
  align-items: center;
  justify-content: flex-start;
  height: 24px;
  gap: 4px;
}

.dropdownPredict svg {
  flex-shrink: 0;
}

.nav-icon {
  color: #505353;
}

.pageTitle {
  color: #505353;
  text-decoration: none;
  font-size: 16px;
}

.icon-active {
  color: #00A1A1 !important;
}

.icon-active .nav-icon {
  color: #00A1A1;
}

.router-link-exact-active {
  color: #00A1A1 !important;
}

.router-link-exact-active .nav-icon {
  color: #00A1A1;
}

.verticalDivider {
  width: 2px;
  height: 27px;
  background-color: #D4D4D4;
}

.dropdown-text,
.barItemText {
  font-size: 16px;
  white-space: pre-line;
  text-align: left;
  word-break: keep-all;
  overflow-wrap: anywhere;
}

.toggle-button {
  transition: transform 0.3s ease;
  border-radius: 100%;
}

.toggle-button.is-fixed {
  transform: rotate(180deg);
}

.toggle-button svg {
  transition: fill 0.3s ease;
}

.toggle-button:hover {
  background-color: #EFF1F0;
}

.insights-active {
  color: #00A1A1 !important;
}

.svg-active path {
  fill: #00A1A1 !important;
}

.text-active {
  color: #00A1A1 !important;
}

.drawer-overlay {
  position: fixed !important;
  left: 0;
  top: 0;
  bottom: 0;
  z-index: 2000;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

.is-collapsed :deep(.v-list-group__items .v-list-item) {
  padding-inline-start: 16px !important;
}

.nav-scroll {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
}

.nav-scroll::-webkit-scrollbar {
  width: 6px;
}

.nav-scroll::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}

.no-wrap-during-transition {
  white-space: nowrap !important;
  overflow: hidden;
  text-overflow: ellipsis;
}

.transition-text {
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  opacity: 1;
  transition: opacity 0.2s ease, max-width 0.2s ease;
}

.transition-text.collapsed {
  opacity: 0;
  max-width: 0;
}

.nav-icon,
.v-list-group__items svg {
  flex-shrink: 0;
}

:deep(.mdi-menu-down) {
  width: 24px;
  height: 24px;
  font-size: 24px;
}

:deep(.mdi-menu-up) {
  width: 24px;
  height: 24px;
  font-size: 24px;
}
</style>
